// extracted by mini-css-extract-plugin
export default {"icon":"SvgIcon_icon__wimZk","infoIcon":"SvgIcon_infoIcon__U0lD+"};